<template>
  <div></div>
</template>

<script>
import { getSMSFrom } from "@/utils/lib/tools";
import { commonDialog, warningNotify, commonNotify } from "@/utils/lib/toast";

export default {
  created() {
    console.log(this.$baseConfig.getWxCodeAndStateUrl);
    console.log(this.$route.query);
    sessionStorage.setItem(getSMSFrom.SCAN_MODEL, this.$route.query.model);
    sessionStorage.setItem(getSMSFrom.SCAN_IDENTITY, this.$route.query.id);

    // console.log(this.$store.state.changeSomeThing.model);
    // return;
    new Promise((ok, err) => {
      this.templogin(ok);
    })
      .then(() => {
        commonNotify("扫码成功", this);
        if(this.$cookie.get("cookieObjByWx") !== null || this.$cookie.get("cookieObjByUserid")){
          return new Promise((ok, err) => {
            this.$http
              .reqPostScanned({
                identity: this.$route.query.id,
                model: this.$route.query.model * 1,
              })
              .then((resp) => {
                console.log(resp);
                if (resp.rtncode == 1) {
                  if (resp.rltcode == 1) {
                    setTimeout(() => {
                      ok();
                    }, 1000);
                  } else {
                    commonDialog(res.rltdesc, this, "关闭页面", () => {
                      this.closePop();
                    });
                  }
                } else {
                  commonDialog(res.rtndesc, this, "关闭页面", () => {
                    this.closePop();
                  });
                }
              });
          });
        }else{
          //提示登录
          return  new Promise((ok, err) => {
            commonDialog('请先登录!', this, "关闭页面", () => {
              this.closePop();
            });
            setTimeout(() => {
              this.closePop();
            }, 5000);
          })
        }
      })
      .then(() => {
        this.getWxPromise();
      });
  },
  methods: {
    // 临时登录
    templogin(ok) {
      this.$http.reqTempLogin().then((resp) => {
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            if (
              resp.accounttype === 0 &&
             sessionStorage.getItem("userId") === null &&
              this.$cookie.get("cookieObj") === null
            ) {
              console.log("resp临时登录66666", resp);
              this.$store.commit("user/setUserId", resp.userid);
              this.$store.commit("user/setUserGuid", resp.userguid);
              this.$store.commit("user/setRealName", resp.realname);
              this.$store.commit("user/setToken", resp.token);
              this.$store.commit("user/setMobileNum", resp.mobilenum);
              this.$store.commit("user/setAccountType", resp.accounttype);
              this.$store.commit("user/setPermission", resp.permission);
              this.$store.commit("user/setAccountStatus", resp.accountstatus);
              this.$store.commit("user/setShowMsg", resp.showmsg)
              this.$store.commit("user/setMaxOpenNum", resp.maxopendocnum)
              this.$store.commit("user/setOpenNum", resp.opendocnum)
              this.$store.commit("user/setMaxToken", resp.maxtokens)
              this.$store.commit("user/setMallVer", resp.mallver)

              if (resp.permission != null && resp.permission.length > 0) {
                let items = [];
                resp.permission.forEach((item) => {
                  items.push(item.f);
                });
                this.$store.commit("user/setPermissionArray", items);
              }

              localStorage.setItem("userguid", resp.userguid);
              sessionStorage.setItem("token", resp.token);
            }
            ok();
          }
        }
      });
    },
    // 获取微信授权
    getWxPromise() {
      let req = {
        http_redirct: this.$baseConfig.getWxCodeAndStateUrl,
      };
      console.log(req);
      // return;
      this.$http
        .reqPostGetWeixinPromise(req)
        .then((res) => {
          console.log("res1233", res); // 返回的
          location.href = res.item.url;
        })
        .catch((err) => {
          console.log("微信拉取授权=====>", err);
        });
    },
    // 关闭页面
    closePop() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.call("closeWindow");
        },
        false
      );
      //这个可以关闭ios系统的手机
      // eslint-disable-next-line no-undef
      WeixinJSBridge.call("closeWindow");
    },
  },
};
</script>

<style lang="less" scoped></style>
